/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter - Generation API
 * API для генерации вакансий и вопросов с помощью AI. Отдельный модуль для всех операций генерации. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ai@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Стандартный ответ об ошибке
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * Список ошибок валидации
     * @type {Array<string>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PositionDataGenerationRequest
 */
export interface PositionDataGenerationRequest {
    /**
     * Описание вакансии для генерации данных
     * @type {string}
     * @memberof PositionDataGenerationRequest
     */
    'description': string;
    /**
     * 
     * @type {PositionDataGenerationRequestExistingData}
     * @memberof PositionDataGenerationRequest
     */
    'existingData'?: PositionDataGenerationRequestExistingData;
}
/**
 * Существующие данные вакансии (опционально)
 * @export
 * @interface PositionDataGenerationRequestExistingData
 */
export interface PositionDataGenerationRequestExistingData {
    /**
     * Существующий заголовок
     * @type {string}
     * @memberof PositionDataGenerationRequestExistingData
     */
    'title'?: string;
    /**
     * Существующие темы
     * @type {Array<string>}
     * @memberof PositionDataGenerationRequestExistingData
     */
    'topics'?: Array<string>;
    /**
     * Существующий статус
     * @type {string}
     * @memberof PositionDataGenerationRequestExistingData
     */
    'status'?: string;
    /**
     * Существующие теги
     * @type {Array<string>}
     * @memberof PositionDataGenerationRequestExistingData
     */
    'tags'?: Array<string>;
    /**
     * Существующее описание
     * @type {string}
     * @memberof PositionDataGenerationRequestExistingData
     */
    'suggestedDescription'?: string;
}
/**
 * 
 * @export
 * @interface PositionDataGenerationResponse
 */
export interface PositionDataGenerationResponse {
    /**
     * 
     * @type {PositionDataGenerationResponseGeneratedData}
     * @memberof PositionDataGenerationResponse
     */
    'generatedData'?: PositionDataGenerationResponseGeneratedData;
    /**
     * Уверенность в генерации (0-1)
     * @type {number}
     * @memberof PositionDataGenerationResponse
     */
    'confidence'?: number;
    /**
     * Сообщение о результатах генерации
     * @type {string}
     * @memberof PositionDataGenerationResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface PositionDataGenerationResponseGeneratedData
 */
export interface PositionDataGenerationResponseGeneratedData {
    /**
     * Сгенерированный заголовок вакансии
     * @type {string}
     * @memberof PositionDataGenerationResponseGeneratedData
     */
    'title'?: string;
    /**
     * Сгенерированные темы для собеседования
     * @type {Array<string>}
     * @memberof PositionDataGenerationResponseGeneratedData
     */
    'topics'?: Array<string>;
    /**
     * Предлагаемый статус позиции
     * @type {string}
     * @memberof PositionDataGenerationResponseGeneratedData
     */
    'status'?: PositionDataGenerationResponseGeneratedDataStatus;
    /**
     * Предлагаемый уровень позиции
     * @type {string}
     * @memberof PositionDataGenerationResponseGeneratedData
     */
    'level'?: PositionDataGenerationResponseGeneratedDataLevel;
    /**
     * Сгенерированные теги
     * @type {Array<string>}
     * @memberof PositionDataGenerationResponseGeneratedData
     */
    'tags'?: Array<string>;
    /**
     * Улучшенное описание вакансии
     * @type {string}
     * @memberof PositionDataGenerationResponseGeneratedData
     */
    'suggestedDescription'?: string;
}

export const PositionDataGenerationResponseGeneratedDataStatus = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
    CLOSED: 'CLOSED',
    ARCHIVED: 'ARCHIVED'
} as const;

export type PositionDataGenerationResponseGeneratedDataStatus = typeof PositionDataGenerationResponseGeneratedDataStatus[keyof typeof PositionDataGenerationResponseGeneratedDataStatus];
export const PositionDataGenerationResponseGeneratedDataLevel = {
    JUNIOR: 'JUNIOR',
    MIDDLE: 'MIDDLE',
    SENIOR: 'SENIOR',
    LEAD: 'LEAD'
} as const;

export type PositionDataGenerationResponseGeneratedDataLevel = typeof PositionDataGenerationResponseGeneratedDataLevel[keyof typeof PositionDataGenerationResponseGeneratedDataLevel];


/**
 * GenerationApi - axios parameter creator
 * @export
 */
export const GenerationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Генерирует краткое описание вакансии для предварительного просмотра. Не используется для создания или редактирования вакансии. 
         * @summary Генерировать описание для overview
         * @param {string} positionDescription Описание вакансии для генерации overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDescription: async (positionDescription: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionDescription' is not null or undefined
            assertParamExists('generateDescription', 'positionDescription', positionDescription)
            const localVarPath = `/generation/description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (positionDescription !== undefined) {
                localVarQueryParameter['positionDescription'] = positionDescription;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Генерирует структурированные данные вакансии на основе описания. Создает title, topics, status, tags, suggestedDescription. Используется для верхней кнопки генерации. 
         * @summary Генерировать основные данные вакансии
         * @param {PositionDataGenerationRequest} positionDataGenerationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePositionData: async (positionDataGenerationRequest: PositionDataGenerationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionDataGenerationRequest' is not null or undefined
            assertParamExists('generatePositionData', 'positionDataGenerationRequest', positionDataGenerationRequest)
            const localVarPath = `/generation/position/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionDataGenerationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Генерирует список вопросов для собеседования на основе описания вакансии. Используется для нижней кнопки генерации. 
         * @summary Генерировать вопросы для вакансии
         * @param {string} positionDescription Описание вакансии для генерации вопросов
         * @param {number} [questionsCount] Количество вопросов для генерации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePositionQuestions: async (positionDescription: string, questionsCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionDescription' is not null or undefined
            assertParamExists('generatePositionQuestions', 'positionDescription', positionDescription)
            const localVarPath = `/generation/position/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (positionDescription !== undefined) {
                localVarQueryParameter['positionDescription'] = positionDescription;
            }

            if (questionsCount !== undefined) {
                localVarQueryParameter['questionsCount'] = questionsCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Перегенерирует вопрос на основе нового описания вакансии. Принимает текущий вопрос и новое описание для перегенерации. 
         * @summary Перегенерировать отдельный вопрос
         * @param {string} currentQuestion Текущий вопрос для перегенерации
         * @param {string} newDescription Новое описание вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateQuestion: async (currentQuestion: string, newDescription: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentQuestion' is not null or undefined
            assertParamExists('generateQuestion', 'currentQuestion', currentQuestion)
            // verify required parameter 'newDescription' is not null or undefined
            assertParamExists('generateQuestion', 'newDescription', newDescription)
            const localVarPath = `/generation/question`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (currentQuestion !== undefined) {
                localVarQueryParameter['currentQuestion'] = currentQuestion;
            }

            if (newDescription !== undefined) {
                localVarQueryParameter['newDescription'] = newDescription;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GenerationApi - functional programming interface
 * @export
 */
export const GenerationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GenerationApiAxiosParamCreator(configuration)
    return {
        /**
         * Генерирует краткое описание вакансии для предварительного просмотра. Не используется для создания или редактирования вакансии. 
         * @summary Генерировать описание для overview
         * @param {string} positionDescription Описание вакансии для генерации overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDescription(positionDescription: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDescription(positionDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GenerationApi.generateDescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Генерирует структурированные данные вакансии на основе описания. Создает title, topics, status, tags, suggestedDescription. Используется для верхней кнопки генерации. 
         * @summary Генерировать основные данные вакансии
         * @param {PositionDataGenerationRequest} positionDataGenerationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePositionData(positionDataGenerationRequest: PositionDataGenerationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionDataGenerationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePositionData(positionDataGenerationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GenerationApi.generatePositionData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Генерирует список вопросов для собеседования на основе описания вакансии. Используется для нижней кнопки генерации. 
         * @summary Генерировать вопросы для вакансии
         * @param {string} positionDescription Описание вакансии для генерации вопросов
         * @param {number} [questionsCount] Количество вопросов для генерации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePositionQuestions(positionDescription: string, questionsCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePositionQuestions(positionDescription, questionsCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GenerationApi.generatePositionQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Перегенерирует вопрос на основе нового описания вакансии. Принимает текущий вопрос и новое описание для перегенерации. 
         * @summary Перегенерировать отдельный вопрос
         * @param {string} currentQuestion Текущий вопрос для перегенерации
         * @param {string} newDescription Новое описание вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateQuestion(currentQuestion: string, newDescription: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateQuestion(currentQuestion, newDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GenerationApi.generateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GenerationApi - factory interface
 * @export
 */
export const GenerationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GenerationApiFp(configuration)
    return {
        /**
         * Генерирует краткое описание вакансии для предварительного просмотра. Не используется для создания или редактирования вакансии. 
         * @summary Генерировать описание для overview
         * @param {string} positionDescription Описание вакансии для генерации overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDescription(positionDescription: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generateDescription(positionDescription, options).then((request) => request(axios, basePath));
        },
        /**
         * Генерирует структурированные данные вакансии на основе описания. Создает title, topics, status, tags, suggestedDescription. Используется для верхней кнопки генерации. 
         * @summary Генерировать основные данные вакансии
         * @param {PositionDataGenerationRequest} positionDataGenerationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePositionData(positionDataGenerationRequest: PositionDataGenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PositionDataGenerationResponse> {
            return localVarFp.generatePositionData(positionDataGenerationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Генерирует список вопросов для собеседования на основе описания вакансии. Используется для нижней кнопки генерации. 
         * @summary Генерировать вопросы для вакансии
         * @param {string} positionDescription Описание вакансии для генерации вопросов
         * @param {number} [questionsCount] Количество вопросов для генерации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePositionQuestions(positionDescription: string, questionsCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.generatePositionQuestions(positionDescription, questionsCount, options).then((request) => request(axios, basePath));
        },
        /**
         * Перегенерирует вопрос на основе нового описания вакансии. Принимает текущий вопрос и новое описание для перегенерации. 
         * @summary Перегенерировать отдельный вопрос
         * @param {string} currentQuestion Текущий вопрос для перегенерации
         * @param {string} newDescription Новое описание вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateQuestion(currentQuestion: string, newDescription: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generateQuestion(currentQuestion, newDescription, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GenerationApi - object-oriented interface
 * @export
 * @class GenerationApi
 * @extends {BaseAPI}
 */
export class GenerationApi extends BaseAPI {
    /**
     * Генерирует краткое описание вакансии для предварительного просмотра. Не используется для создания или редактирования вакансии. 
     * @summary Генерировать описание для overview
     * @param {string} positionDescription Описание вакансии для генерации overview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenerationApi
     */
    public generateDescription(positionDescription: string, options?: RawAxiosRequestConfig) {
        return GenerationApiFp(this.configuration).generateDescription(positionDescription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Генерирует структурированные данные вакансии на основе описания. Создает title, topics, status, tags, suggestedDescription. Используется для верхней кнопки генерации. 
     * @summary Генерировать основные данные вакансии
     * @param {PositionDataGenerationRequest} positionDataGenerationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenerationApi
     */
    public generatePositionData(positionDataGenerationRequest: PositionDataGenerationRequest, options?: RawAxiosRequestConfig) {
        return GenerationApiFp(this.configuration).generatePositionData(positionDataGenerationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Генерирует список вопросов для собеседования на основе описания вакансии. Используется для нижней кнопки генерации. 
     * @summary Генерировать вопросы для вакансии
     * @param {string} positionDescription Описание вакансии для генерации вопросов
     * @param {number} [questionsCount] Количество вопросов для генерации
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenerationApi
     */
    public generatePositionQuestions(positionDescription: string, questionsCount?: number, options?: RawAxiosRequestConfig) {
        return GenerationApiFp(this.configuration).generatePositionQuestions(positionDescription, questionsCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Перегенерирует вопрос на основе нового описания вакансии. Принимает текущий вопрос и новое описание для перегенерации. 
     * @summary Перегенерировать отдельный вопрос
     * @param {string} currentQuestion Текущий вопрос для перегенерации
     * @param {string} newDescription Новое описание вакансии
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenerationApi
     */
    public generateQuestion(currentQuestion: string, newDescription: string, options?: RawAxiosRequestConfig) {
        return GenerationApiFp(this.configuration).generateQuestion(currentQuestion, newDescription, options).then((request) => request(this.axios, this.basePath));
    }
}



